<script setup lang="ts">
import type { ChipProps } from "./chip.types";
import { useChip } from "./useChip";

defineOptions({ name: "EChip", inheritAttrs: false });

const props = withDefaults(defineProps<ChipProps>(), {
  color: "neutral",
  variant: "subtle",
  size: "md",
});

const { classes, hasDefaultSlot } = useChip({ props });
</script>

<template>
  <e-primitive as="span" exportparts="icon,trailing-icon" :inner-class="classes" class="e-chip" v-bind="$attrs">
    <e-icon v-if="props.icon" exportparts="base:icon" :name="props.icon" />
    <slot />
    <template v-if="!hasDefaultSlot">{{ props.text }}</template>
    <e-icon v-if="props.trailingIcon" exportparts="base:trailing-icon" :name="props.trailingIcon" />
  </e-primitive>
</template>

<style>
:host {
  display: contents;
}
</style>
